import { createContext, useContext } from "react";

interface WineDetailsContextProps {
  closeWineDetailsTray: () => void;
}

const initialState: WineDetailsContextProps = {
  closeWineDetailsTray: () => {},
};

export const WineDetailsContext = createContext<WineDetailsContextProps>(initialState);

export const useWineDetailsContext = () => useContext(WineDetailsContext);
